<template>
    <div class="availability-submit">
        <button
            :disabled="disabled"
            type="submit"
            class="btn btn-yellow btn-shine"
            @click="logBookingStarted"
        >
            <template v-if="loading">
                <span>
                    <i class="fa fa-spinner fa-spin"/>
                    {{ loading }}
                </span>
            </template>
            <template v-else-if="isQuoteValueValid">
                <span>
                    <i class="icons8-lightning-bolt"/>
                    {{ quote.value === 0 ? 'Continue' : 'Book Now' }}
                </span>
            </template>
            <template v-else-if="availableFrom && spaceEnabled && !spaceDummy && !spaceWaiting">
                <span>
                    <i class="icons8-lightning-bolt"/>
                    Book From {{ availableFrom }}
                </span>
            </template>
            <template v-else>
                <span>{{ quoteFailedButtonText }}</span>
            </template>
        </button>
    </div>
</template>

<script>
    import moment from '../../../modules/moment';
    import { googleBookingStarted } from '../../../modules/google-analytics';
    import storeFormSync from '../../../store/form-sync';

    export default {
        name: 'availability-submit',

        props: {
            quote: {
                type: Object,
                default() {
                    return {};
                },
            },

            availableFrom: {
                type: String,
                default() {
                    return null;
                },
            },

            ltAvailableFrom: {
                type: Object,
                default() {
                    return {};
                },
            },

            spaceEnabled: {
                type: Boolean,
                default() {
                    return true;
                },
            },

            spaceDummy: {
                type: Boolean,
                default() {
                    return false;
                },
            },

            spaceWaiting: {
                type: Boolean,
                default() {
                    return false;
                },
            },

            startDate: {
                type: String,
                default() {
                    return false;
                },
            },

            loading: {
                type: [Boolean, String],
                default() {
                    return null;
                },
            },
        },

        data() {
            return {
                states: {
                    errors: [],
                },
            };
        },

        computed: {
            ...storeFormSync([
                'search.data.rental',
                'booking.space',
            ]),

            /**
             * Returns true if the quote value is 0 or greater.
             *
             * @returns {boolean}
             */
            isQuoteValueValid() {
                return this.quote.value >= 0;
            },

            disabled() {
                return (!this.isQuoteValueValid && !this.availableFrom)
                    || (this.spaceWaiting && moment(this.startDate, 'DD-MM-YYYY').isBefore(this.ltAvailableFrom))
                    || this.loading
                    || !this.spaceEnabled
                    || this.spaceDummy;
            },

            quoteFailedButtonText() {
                if (this.states.errors.includes('this space is unavailable on the day')) {
                    return 'Please select alternative dates/times';
                }

                return 'Could not get quote';
            },
        },

        methods: {
            logBookingStarted() {
                googleBookingStarted({
                    value: this.quote.value + this.quote.serviceFee,
                    price: this.quote.value,
                    term: this.rental,
                    title: this.space.title,
                    id: this.space.id,
                });
            },
        },
    };
</script>
